export default __webpack_public_path__ + "static/media/701.38aefcd6.gif";